<template>
  <div class="c-global-loader">
    <div class="c-global-loader__container">
      <svg
        class="c-global-loader__shape"
        preserveAspectRatio="xMidYMid meet"
        viewBox="124 269.5 128 128"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g opacity="1" transform="matrix(1,0,0,1,187.5,333.5)">
          <g opacity="1" transform="matrix(1,0,0,1,0,0)">
            <path
              id="path1"
              ref="path1Element"
              :d="path1[0]"
              fill-opacity="0"
              stroke="rgb(204,0,0)"
              stroke-linecap="butt"
              stroke-linejoin="miter"
              stroke-miterlimit="4"
              stroke-opacity="1"
              stroke-width="10"
            ></path>
          </g>
          <g opacity="1" transform="matrix(-1,0,0,-1,0,0)">
            <path
              id="path2"
              ref="path2Element"
              :d="path2[0]"
              fill-opacity="0"
              stroke="rgb(204,0,0)"
              stroke-linecap="butt"
              stroke-linejoin="miter"
              stroke-miterlimit="4"
              stroke-opacity="1"
              stroke-width="10"
            ></path>
          </g>
        </g>
      </svg>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref, type Ref } from 'vue'

const path1 = [
  'M45,0.1080000028014183 C45,22.57200050354004 45,45 45,45 C45,45 22.42799949645996,45 -0.1080000028014183,45',
  'M45,0.3959999978542328 C45,22.76300048828125 45,45 45,45 C45,45 22.235000610351562,45 -0.3959999978542328,45',
  'M45,0.8640000224113464 C45,23.07200050354004 45,45 45,45 C45,45 21.920000076293945,45 -0.8640000224113464,45',
  'M45,1.5839999914169312 C45,23.54400062561035 45,45 45,45 C45,45 21.430999755859375,45 -1.5839999914169312,45',
  'M45,2.5920000076293945 C45,24.195999145507812 45,45 45,45 C45,45 20.738000869750977,45 -2.5920000076293945,45',
  'M45,3.888000011444092 C45,25.020000457763672 45,45 45,45 C45,45 19.829999923706055,45 -3.888000011444092,45',
  'M45,5.6519999504089355 C45,26.118000030517578 45,45 45,45 C45,45 18.56399917602539,45 -5.6519999504089355,45',
  'M45,7.631999969482422 C45,27.31999969482422 45,45 45,45 C45,45 17.100000381469727,45 -7.631999969482422,45',
  'M45,10.116000175476074 C45,28.783000946044922 45,45 45,45 C45,45 15.190999984741211,45 -10.116000175476074,45',
  'M45,13.211999893188477 C45,30.540000915527344 45,45 45,45 C45,45 12.6899995803833,45 -13.211999893188477,45',
  'M45,17.20800018310547 C45,32.707000732421875 45,45 45,45 C45,45 9.230999946594238,45 -17.20800018310547,45',
  'M45,21.816999435424805 C45,35.07500076293945 45,45 45,45 C45,45 4.848999977111816,45 -21.816999435424805,45',
  'M45,27.792999267578125 C45,37.94900131225586 45,45 45,45 C45,45 -1.6679999828338623,45 -27.792999267578125,45',
  'M45,34.95600128173828 C45,41.11399841308594 45,45 45,45 C45,45 -11.482000350952148,45 -34.95600128173828,45',
  'M45,43.99399948120117 C45,44.650001525878906 45,45 45,45 C45,45 -34.12799835205078,45 -43.99399948120117,45',
  'M34.130001068115234,45 C10.1850004196167,45 -45,45 -45,45 C-45,45 -45,40.763999938964844 -45,34.130001068115234',
  'M18.4689998626709,45 C-8.07800006866455,45 -45,45 -45,45 C-45,45 -45,33.36899948120117 -45,18.4689998626709',
  'M0.25200000405311584,45 C-22.332000732421875,45 -45,45 -45,45 C-45,45 -45,22.667999267578125 -45,0.25200000405311584',
  'M-19.799999237060547,45 C-34.055999755859375,45 -45,45 -45,45 C-45,45 -45,6.824999809265137 -45,-19.799999237060547',
  'M-35.89400100708008,45 C-41.50600051879883,45 -45,45 -45,45 C-45,45 -45,-13.026000022888184 -45,-35.89400100708008',
  'M-45,41.32899856567383 C-45,24.437000274658203 -45,-45 -45,-45 C-45,-45 -43.667999267578125,-45 -41.32899856567383,-45',
  'M-45,31.35700035095215 C-45,6.190000057220459 -45,-45 -45,-45 C-45,-45 -39.56100082397461,-45 -31.35700035095215,-45',
  'M-45,24.37299919128418 C-45,-2.197000026702881 -45,-45 -45,-45 C-45,-45 -36.33000183105469,-45 -24.37299919128418,-45',
  'M-45,18.361000061035156 C-45,-8.178000450134277 -45,-45 -45,-45 C-45,-45 -33.3120002746582,-45 -18.361000061035156,-45',
  'M-45,13.680000305175781 C-45,-12.298999786376953 -45,-45 -45,-45 C-45,-45 -30.799999237060547,-45 -13.680000305175781,-45',
  'M-45,10.116000175476074 C-45,-15.190999984741211 -45,-45 -45,-45 C-45,-45 -28.783000946044922,-45 -10.116000175476074,-45',
  'M-45,7.343999862670898 C-45,-17.31599998474121 -45,-45 -45,-45 C-45,-45 -27.14699935913086,-45 -7.343999862670898,-45',
  'M-45,5.1479997634887695 C-45,-18.93000030517578 -45,-45 -45,-45 C-45,-45 -25.80699920654297,-45 -5.1479997634887695,-45',
  'M-45,3.312000036239624 C-45,-20.236000061035156 -45,-45 -45,-45 C-45,-45 -24.6560001373291,-45 -3.312000036239624,-45',
  'M-45,2.052000045776367 C-45,-21.111000061035156 -45,-45 -45,-45 C-45,-45 -23.847999572753906,-45 -2.052000045776367,-45',
  'M-45,1.0800000429153442 C-45,-21.77400016784668 -45,-45 -45,-45 C-45,-45 -23.214000701904297,-45 -1.0800000429153442,-45',
  'M-45,0.46799999475479126 C-45,-22.187000274658203 -45,-45 -45,-45 C-45,-45 -22.81100082397461,-45 -0.46799999475479126,-45',
  'M-45,0.1080000028014183 C-45,-22.42799949645996 -45,-45 -45,-45 C-45,-45 -22.57200050354004,-45 -0.1080000028014183,-45',
  'M-45,0 C-45,-22.5 -45,-45 -45,-45 C-45,-45 -22.5,-45 0,-45',
  'M-45,0 C-45,-22.5 -45,-45 -45,-45 C-45,-45 -22.5,-45 0,-45',
  'M45,0 C45,22.5 45,45 45,45 C45,45 22.5,45 0,45',
]
const path2 = [
  'M45,0.07199999690055847 C45,22.54800033569336 45,45 45,45 C45,45 22.45199966430664,45 -0.07199999690055847,45',
  'M45,0.36000001430511475 C45,22.73900032043457 45,45 45,45 C45,45 22.259000778198242,45 -0.36000001430511475,45',
  'M45,0.8640000224113464 C45,23.07200050354004 45,45 45,45 C45,45 21.920000076293945,45 -0.8640000224113464,45',
  'M45,1.5479999780654907 C45,23.520000457763672 45,45 45,45 C45,45 21.45599937438965,45 -1.5479999780654907,45',
  'M45,2.555999994277954 C45,24.17300033569336 45,45 45,45 C45,45 20.76300048828125,45 -2.555999994277954,45',
  'M45,3.8519999980926514 C45,24.996999740600586 45,45 45,45 C45,45 19.856000900268555,45 -3.8519999980926514,45',
  'M45,5.507999897003174 C45,26.030000686645508 45,45 45,45 C45,45 18.66900062561035,45 -5.507999897003174,45',
  'M45,7.631999969482422 C45,27.31999969482422 45,45 45,45 C45,45 17.100000381469727,45 -7.631999969482422,45',
  'M45,10.079999923706055 C45,28.761999130249023 45,45 45,45 C45,45 15.218999862670898,45 -10.079999923706055,45',
  'M45,13.28499984741211 C45,30.579999923706055 45,45 45,45 C45,45 12.630000114440918,45 -13.28499984741211,45',
  'M45,17.100000381469727 C45,32.650001525878906 45,45 45,45 C45,45 9.32800006866455,45 -17.100000381469727,45',
  'M45,21.7450008392334 C45,35.03900146484375 45,45 45,45 C45,45 4.921999931335449,45 -21.7450008392334,45',
  'M45,27.253000259399414 C45,37.698001861572266 45,45 45,45 C45,45 -1.0299999713897705,45 -27.253000259399414,45',
  'M45,34.777000427246094 C45,41.03799819946289 45,45 45,45 C45,45 -11.196999549865723,45 -34.777000427246094,45',
  'M45,43.308998107910156 C45,44.40399932861328 45,45 45,45 C45,45 -30.948999404907227,45 -43.308998107910156,45',
  'M35.02899932861328,45 C11.598999977111816,45 -45,45 -45,45 C-45,45 -45,41.14400100708008 -45,35.02899932861328',
  'M20.089000701904297,45 C-6.547999858856201,45 -45,45 -45,45 C-45,45 -45,34.202999114990234 -45,20.089000701904297',
  'M0.46799999475479126,45 C-22.187000274658203,45 -45,45 -45,45 C-45,45 -45,22.81100082397461 -45,0.46799999475479126',
  'M-19.04400062561035,45 C-33.66699981689453,45 -45,45 -45,45 C-45,45 -45,7.540999889373779 -45,-19.04400062561035',
  'M-35.388999938964844,45 C-41.29499816894531,45 -45,45 -45,45 C-45,45 -45,-12.1850004196167 -45,-35.388999938964844',
  'M-45,41.4739990234375 C-45,24.836999893188477 -45,-45 -45,-45 C-45,-45 -43.722999572753906,-45 -41.4739990234375,-45',
  'M-45,31.716999053955078 C-45,6.679999828338623 -45,-45 -45,-45 C-45,-45 -39.71900177001953,-45 -31.716999053955078,-45',
  'M-45,24.44499969482422 C-45,-2.119999885559082 -45,-45 -45,-45 C-45,-45 -36.3650016784668,-45 -24.44499969482422,-45',
  'M-45,18.4689998626709 C-45,-8.07800006866455 -45,-45 -45,-45 C-45,-45 -33.36899948120117,-45 -18.4689998626709,-45',
  'M-45,13.968000411987305 C-45,-12.055999755859375 -45,-45 -45,-45 C-45,-45 -30.958999633789062,-45 -13.968000411987305,-45',
  'M-45,10.331999778747559 C-45,-15.020999908447266 -45,-45 -45,-45 C-45,-45 -28.906999588012695,-45 -10.331999778747559,-45',
  'M-45,7.380000114440918 C-45,-17.288999557495117 -45,-45 -45,-45 C-45,-45 -27.16900062561035,-45 -7.380000114440918,-45',
  'M-45,5.21999979019165 C-45,-18.878000259399414 -45,-45 -45,-45 C-45,-45 -25.851999282836914,-45 -5.21999979019165,-45',
  'M-45,3.4200000762939453 C-45,-20.15999984741211 -45,-45 -45,-45 C-45,-45 -24.724000930786133,-45 -3.4200000762939453,-45',
  'M-45,2.052000045776367 C-45,-21.111000061035156 -45,-45 -45,-45 C-45,-45 -23.847999572753906,-45 -2.052000045776367,-45',
  'M-45,1.1160000562667847 C-45,-21.75 -45,-45 -45,-45 C-45,-45 -23.238000869750977,-45 -1.1160000562667847,-45',
  'M-45,0.46799999475479126 C-45,-22.187000274658203 -45,-45 -45,-45 C-45,-45 -22.81100082397461,-45 -0.46799999475479126,-45',
  'M-45,0.1080000028014183 C-45,-22.42799949645996 -45,-45 -45,-45 C-45,-45 -22.57200050354004,-45 -0.1080000028014183,-45',
  'M-45,0 C-45,-22.5 -45,-45 -45,-45 C-45,-45 -22.5,-45 0,-45',
  'M-45,0 C-45,-22.5 -45,-45 -45,-45 C-45,-45 -22.5,-45 0,-45',
  'M45,0 C45,22.5 45,45 45,45 C45,45 22.5,45 0,45',
]

const path1Element: Ref<HTMLElement | null> = ref(null)
const path2Element: Ref<HTMLElement | null> = ref(null)
const fps = 46
let frame = 0

const animate = () => {
  if (!path1Element.value || !path2Element.value) return

  path1Element.value.setAttribute('d', path1[frame])
  path2Element.value.setAttribute('d', path2[frame])

  frame = frame !== path1.length - 1 ? frame + 1 : 0

  setTimeout(function () {
    requestAnimationFrame(animate)
  }, 1000 / fps)
}

onMounted(() => {
  animate()
})
</script>

<style lang="scss" scoped>
.c-global-loader {
  position: fixed;
  background-color: #f7f8fb;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-left: calc(100vw - 100%);

  &__container {
    width: 200px;
    height: 200px;
  }

  &__shape {
    width: 100%;
    height: 100%;
    transform: translate3d(0, 0, 0);
    opacity: 0;
    animation: svg-fade 0.25s ease-in-out forwards;
  }
}

@keyframes svg-fade {
  to {
    opacity: 1;
  }
}
</style>
